export const manufacturingSelection = {
  continuousDyeing: '连续染色',
  exhaustDyeing: '浸染法',
  laundry: '洗衣',
  leather: '皮革加工',
  overallPrinting: '整体印花',
  other: '干法工艺',
  positionalPrinting: '定位印花'
};
